// packages block
import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import { FC, KeyboardEvent, useContext } from 'react';
// components block
import { CrossIcon } from '../../assets/images';
// others block
import { AppContext } from '../../context/AppContext';
import { ActionType } from '../../context/AppContextReducer';
import { SearchWithSortProps } from '../../interfaceTypes';

export const KeyPressSearch: FC<SearchWithSortProps> = ({ searchPlaceholder, loading }): JSX.Element => {
  const { dispatch: reducerDispatch, searchValue, isLoading } = useContext(AppContext)

  const searchHandler = (value: string) => {
    reducerDispatch({ type: ActionType.SET_SEARCH_VALUE, searchValue: value })
    reducerDispatch({ type: ActionType.SET_CURRENT_PAGE, currentPage: 1 })
  }

  const keyDownSearchHandler = (event: KeyboardEvent<HTMLInputElement>) => {
    const { key } = event

    if (key === "Enter") {
      reducerDispatch({ type: ActionType.SET_SEARCH_VALUE, searchValue: searchValue })
      reducerDispatch({ type: ActionType.SET_CURRENT_PAGE, currentPage: 1 })
    }
  }

  const clearSearchHandler = () => reducerDispatch({ type: ActionType.SET_SEARCH_VALUE, searchValue: '' })

  return (
    <Box display='flex' justifyContent='space-between' alignItems='center' padding='15px' flexWrap='wrap' gap='20px'>
      <Box maxWidth={350} width='100%'>
        {searchPlaceholder &&
          <TextField
            label={searchPlaceholder}
            onChange={({ target: { value } }) => {
              searchHandler(value)
            }}
            value={searchValue}
            onKeyDown={keyDownSearchHandler}
            disabled={isLoading || loading}
            fullWidth
            size="small"
            variant="outlined"
            InputProps={{
              endAdornment: searchValue ?
                <InputAdornment position='end' onClick={clearSearchHandler}>
                  <IconButton sx={{ p: 0, "svg": { maxWidth: '10px' } }} onClick={clearSearchHandler} aria-label='clear search'>
                    <CrossIcon />
                  </IconButton>
                </InputAdornment>
                :
                undefined
            }}
          />
        }
      </Box>
    </Box>
  )
}
